import Helpers from '../../helpers/helpers';
import Notification, { INotification } from '../notification/notification';

export default class BrowserNotification extends Notification {
    static initSelector: string = '.browser-notification';

    public static get shouldShow(): boolean {
        const ieVer: number | boolean = Helpers.isIE;

        return window.sessionStorage.getItem('gotoandplay_old_browser') !== 'accepted' && ieVer && ieVer <= 11;
    }

    public static render(data: INotification, className: string = ''): HTMLElement {
        return super.render(data, ['browser-notification', className].join(' '));
    }

    remove(): void {
        window.sessionStorage.setItem('gotoandplay_old_browser', 'accepted');

        super.remove();
    }
}
